import React, { useState } from 'react';
import { Tab, Tabs, Box } from '@mui/material';
import UserMobileLogs from './UserMobileLogs';

interface AssociatedImeiTabsProps {
  associatedImeis: string[];
}

const AssociatedImeiTabs = ({ associatedImeis }: AssociatedImeiTabsProps) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  if (!associatedImeis || associatedImeis.length === 0) {
    return <div>No IMEIs available</div>;
  }

  return (
    <Box>
      <Tabs value={selectedTab} onChange={handleTabChange} variant='scrollable' scrollButtons='auto'>
        {associatedImeis.map((imei, index) => (
          <Tab key={imei} label={`IMEI: ${imei}`} />
        ))}
      </Tabs>

      <Box sx={{ mt: 2 }}>
        {associatedImeis.map((imei, index) => (
          <div key={imei} role='tabpanel' hidden={selectedTab !== index}>
            {selectedTab === index && <UserMobileLogs imei={imei} />}
          </div>
        ))}
      </Box>
    </Box>
  );
};

export default AssociatedImeiTabs;
